import { faHome, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import styles from './ContactUs.module.css';

const ContactUs = () => {
    return (
        <section className={styles.contactUsWrapper}>
            <Container>
                <Row>
                    <Col md={6} lg={6} xl={4}>
                        <div className={`${styles.singleContact} ${styles.icon1}`}>
                            <div className={styles.cIcon}>
                                <FontAwesomeIcon icon={faHome} />
                            </div>
                            <div className={styles.cInfo}>
                                <h4>Ubícanos</h4>
                                <p>Calle Schell 319</p>
                                <p>Oficina 903</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6} lg={6} xl={4}>
                        <div className={`${styles.singleContact} ${styles.icon2}`}>
                            <div className={styles.cIcon}>
                                <FontAwesomeIcon icon={faEnvelope} />
                            </div>
                            <div className={styles.cInfo}>
                                <h4>Escribenos</h4>
                                <p>info@dentisanclinicadental.com.pe</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6} lg={6} xl={4}>
                        <div className={`${styles.singleContact} ${styles.icon3}`}>
                            <div className={styles.cIcon}>
                                <FontAwesomeIcon icon={faClock} />
                            </div>
                            <div className={styles.cInfo}>
                                <h4>Horario de atención</h4>
                                <p>Lun a Vie 9:00 am - 6:00 pm</p>
                                <p>Sab 9:00 am - 3:00 pm</p>                                
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ContactUs;
